import { InferType, object, string } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'

const Schema = object({
  clientId: string().required(),
})

export type Request = InferType<typeof Schema>

export const url = ({ clientId }: Request) => `/v1/client-consent-enrollments/client/${clientId}`
export type SuccessfulResponse = { isActive?: boolean }
